import React from 'react';
import Router from './components/Router';

import '@brainhubeu/react-carousel/lib/style.css';

function App() {
  return (
    <div style={{ margin: '4rem 0 2.5rem' }}>
      <Router />
    </div>
  );
}

export default App;
